import { AfterViewInit, ChangeDetectionStrategy, Component, computed, HostListener, inject, input, signal } from '@angular/core';
import { NgClass } from '@angular/common';
import { ButtonComponent } from '../buttons/button/button.component';
import { ClickPreventDefaultDirective } from '../directives/click/click-prevent-default.directive';
import { HeadlineComponent } from '../headline/headline.component';
import { InfoTextIconComponent } from '../info-text/info-text-icon.component';
import { InlineNotificationComponent } from './inline-notification.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { SafeHtmlPipe } from '@mwe/ui/pipes';
import { ToastService } from '@mwe/services';
import { Toast } from '@mwe/models';

@Component({
  selector: 'mwe-toast-notification',
  templateUrl: './inline-notification.component.html',
  imports: [
    NgClass,
    HeadlineComponent,
    InfoTextIconComponent,
    ClickPreventDefaultDirective,
    TranslateDirective,
    ButtonComponent,
    TranslatePipe,
    SafeHtmlPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastNotificationComponent extends InlineNotificationComponent implements AfterViewInit {
  private readonly toastService = inject(ToastService);

  toast = input<Toast>(null);
  timeoutDuration = computed<number>(() => this.toast().timeoutDuration || 6000);

  timeOut = signal<number>(null);

  constructor() {
    super();
  }

  ngAfterViewInit() {
    this.startTimer();
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    clearTimeout(this.timeOut());
    this.timeOut.set(null);
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.startTimer();
  }

  startTimer() {
    if (this.toast().staysVisible || this.timeOut()) {
      return;
    }
    this.timeOut.set(
      window.setTimeout(() => {
        this.toastService.removeToast(this.toast().uuid);
        this.timeOut.set(null);
      }, this.timeoutDuration()),
    );
  }
}
